export const formatAddress = (
  address: string
): { streetAddress: string; cityStateZip: string } | null => {
  const pattern = /^(.*?),\s*([^,]+),\s*([^,]+),\s*(\d{5}(?:\s*-\s*\d{4})?)$/;
  const match = address.match(pattern);

  if (!match) return null;

  const streetAddress = match[1];
  const cityStateZip = `${match[2]}, ${match[3]}, ${match[4]}`;

  return { streetAddress, cityStateZip };
};
